import React from "react";
import { useState } from "react";
import { CSVLink } from "react-csv";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import searchWhiteIcon from "../Icon.png";
// import "../OMS order list.css";
import NavBar from "../NavBar";
export default function WarehouseSuppliers(props) {


  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === x.city){
        return x.city
      } 
      else if (e.target.value === 'other') {
        return (x.city !== 'Banglore' && x.city !== 'Mumbai' && x.city !== 'Delhi' && x.city !== 'Chennai' && x.city !== 'Kolkata')
      }
    }));
  };
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Warehouse Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Suppliers</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Suppliers</h2>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="order-list-box" style={{ width: "99%" }}>
          <div id="click-data">
            <p>All Suppliers</p>
            <p>Recently Added</p>
            <p>Recently Removed</p>
          </div>
          <div className="order-list-input-box">
            <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by supplier ID, supplier name..."
              onChange={(val) => {
                setCount(
                    IncomingData.filter((x) =>
                    x.supplierId.match(val.target.value) || x.supplierName.match(val.target.value)
                  )
                );
                setFiltr1('')
              }}
            />              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">
              <select name="" id="" className="order-list-input-right-filters"
               value={filtr1}
              onChange={handleFilter1}
              >
                <option value="" selected>
                  City
                </option>
                <option value="Banglore">Banglore</option>
                <option value="Mumbai">Mumbai</option>
                <option value="Chennai">Chennai</option>
                <option value="Kolkata">Kolkata</option>
                <option value="Delhi">Delhi</option>
                <option value="other">Other</option>

              </select>
              <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
            </div>
          </div>
          <table style={{ textAlign: "center" }}>
            <tr>
              <th>Supplier ID</th>
              <th>Supplier Name</th>
              <th>Company Name</th>
              <th>Address</th>
              <th>City</th>
              <th>Postal Code</th>
              <th>Contact Number</th>
            </tr>
            {count.length > 0
            ? count.map((val) => {
                return (
                  <tr>
                  <td>{val.supplierId}</td>
                  <td>{val.supplierName}</td>
                  <td>{val.companyName}</td>
                  <td>{val.address}</td>
                  <td>{val.city}</td>
                  <td>{val.postalCode}</td>
                  <td>{val.contactNo}</td>
                </tr>
                );
              })
            : IncomingData.map((val) => {
              return (
                <tr>
                  <td>{val.supplierId}</td>
                  <td>{val.supplierName}</td>
                  <td>{val.companyName}</td>
                  <td>{val.address}</td>
                  <td>{val.city}</td>
                  <td>{val.postalCode}</td>
                  <td>{val.contactNo}</td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
}

export const IncomingData = [
  {
    "supplierId": "KCVF1111",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Mumbai',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF5555",
    "supplierName": "Jacob",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Gurgaon',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF5555",
    "supplierName": "Satyam",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Mumbai',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Banglore',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Mumbai',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Banglore',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Banglore',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Kolkata',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Chennai',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Kolkata',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Chennai',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Kolkata',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Kolkata',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF1555",
    "supplierName": "Dom",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Kolkata',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
  {
    "supplierId": "KCVF112L",
    "supplierName": "John Doe",
    'companyName':'Nike',
    'address': `Karol Bagh`,
    'city': 'Delhi',
    'postalCode': '122015',
    'contactNo': 98568745955,
  },
];
